import httpClient from "../httpClient";
import { API_COMORBIDITY_CREATE } from "../config";

const createComorbidity = {
    create: (data) => httpClient.post(API_COMORBIDITY_CREATE, data),
};

export default createComorbidity;
